module.exports = __webpack_public_path__ + "static/media/gradient.944eda7c.svg";